import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Krush65 = () => (
  <ArticleWrapper articleId="krush65">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Krush65</h1>
        <img src="/pictures/gallery/gallery4.JPG" alt="Krush65" className="rounded-lg mb-6" />
        {/* Add your Krush65 article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default Krush65;
